<template>
  <div class="cashflow-category-investigation">
    <div class="cards-container">
      <div class="close-button-container">
        <img class="close-button" :src="require('@/assets/icons/ic-close.svg')" v-on:click="closeModal">
      </div>
      <template v-for="question in this.questions">
        <transition name="fade" mode="out-in" :key="`${question.transactionId}`">
          <cashflow-category-open-card v-if="question.cardOpen" :question="question" />
          <cashflow-category-closed-card v-else :question="question" />
        </transition>
      </template>
    </div>
    <div class="done-btn" v-if="!hasUnansweredQuestions">
      <riseup-button class="riseup-button"
                     :action="() => doneAnswering()"
                     :title="'סיימתי לענות!'"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../Segment';
import CashflowCategoryOpenCard from './CashflowCategoryOpenCard.vue';
import CashflowCategoryClosedCard from './CashflowCategoryClosedCard.vue';

export default {
  name: 'CashflowCategoryInvestigation',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    CashflowCategoryOpenCard,
    CashflowCategoryClosedCard,
  },
  props: {
    onDoneInvestigation: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('CashflowInvestigatorEntered', { cashflowApp: true, questions: this.questions.length });
  },
  computed: {
    ...mapState('cashflowCategoryActions', ['questions']),
    ...mapGetters('cashflowCategoryActions', ['hasUnansweredQuestions']),
  },
  methods: {
    async doneAnswering() {
      this.closeModal();
      Segment.trackUserGot('CashflowInvestigationDoneAnswering');
      await this.onDoneInvestigation();
    },
    async closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .cashflow-category-investigation {
    text-align: right;
    margin: 16px;

    .close-button-container {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .close-button {
        cursor: pointer;
      }
    }

    .intro {
      text-align: right;
      line-height: 1.5;
      margin-bottom: 12px;
    }

    .cards-container {
      .open-card {
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0px;
        }
      }
    }

    .done-btn {
      margin-top: 32px;
      margin-bottom: 24px;
      text-align: center;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.3s linear 0s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
  }
</style>
